<template>
    <div class="TQ_bg_white TQ_borderRadius TQ_padding_8px">

        <tq-image :pb_src_r="ass_gif_trophy" class="TQ_width_100p"/>
        <div class="TQ_text_bold TQ_text_20px TQ_font_SecularOne">
            {{ass_strings.sentence_finishQuest[p_systemLangCode_e]}}
        </div>
    </div>
</template>

<script>
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_screenSizesOptions_n, enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {ass_gif_trophy} from "../../assets/scripts/Ass_Files";
    import TqImage from "../basic/TqImage";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";

    export default {
        name: "trophy",
        components: {TqImage},
        props:{
            p_screenSize_en:{
                type:Number,
                require: true,
                validator(val) {
                    return validator_enum_fb(enum_screenSizesOptions_n, val)
                }
            },
            p_systemLangCode_e:{
                type:String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
        },
        data(){
            return {
                ass_gif_trophy : ass_gif_trophy,
                ass_strings : ass_strings,
            }

        },
        created(){
            switch(this.p_screenSize_en){
                case enum_screenSizesOptions_n.laptop:
                case enum_screenSizesOptions_n.tablet_big:
                case enum_screenSizesOptions_n.tablet_small:
                    this.size_s = "220px"
                    break;
                case enum_screenSizesOptions_n.mobile:
                    this.size_s = "100px"
                    break;

            }
        }


    }
</script>

<style scoped lang="scss">

    // drawCircle
    @keyframes scaleAnimation {
        0% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
    @keyframes scaleInOut {
        0% {
            transform: scale(0.9);
            opacity: 0;
        }
        50% {
            transform: scale(1.1);
            opacity: 1;
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes drawCircle {
        0% {
            stroke-dashoffset: 151px;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
    @keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }


    .fadeIn {
        animation: 0.3s linear 0.9s both fadeIn;
    }

    .scaleInOut1{
        animation: 1s ease-out 0s 1 both scaleInOut;
        transform-origin: center;
    }
    .scaleInOut{
        animation: 1s ease-out 1s 1 both fadeIn;
        transform-origin: center;
    }


    .drawCircle {
        animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle,
        0.3s linear 0.9s 1 both;
    }






</style>